<template>
<div id="removeclass">
   <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("form_styling") }}</h5>
      <!-- <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        @click="closeModal"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button> -->
      <button
        v-if="active == 1"
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
    </template>
    <template slot="body">
      <div class="row">
        <div class="col-sm-12">
          <div v-if="active != 1" class="mb-2">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item v-if="active < 4"> <a href="" @click.prevent="previous">Back</a></el-breadcrumb-item>
              <el-breadcrumb-item v-if="active == 2">Edit</el-breadcrumb-item>
              <el-breadcrumb-item v-if="active == 3">View</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-form v-if="active === 1">
            <div class="text-center">
              <button type="button" class="btn btn-primary" @click="chooseExisting">Choose Existing Style</button>
              <button type="button" class="btn btn-primary" @click="createOwn">Create Your Own</button>
              <button v-if="isDefaultShow" type="button" class="btn btn-primary" @click="chooseDefault">Choose Default Style</button>
            </div>
          </el-form>
          <el-form v-if="active === 2">
            <form-preview @styling="saveBodystyle"  :formType="formType" :id="form_body_id" :showStyleDiv="showStyleDiv" :hidePrevious="hidePrevious" :formBodyIds="formBodyIds" :back="previous"></form-preview>
          </el-form>
          </div>
      </div>
    </template>
  </app-modal>
</div>
 
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../../app/Helpers/AxiosHelper";



export default {
  name: "ImportFormsStylingModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    formBodyId: Number,
    formId: Number,
    close_modal: Function,
  },
  data() {
    return {
      active: 1,
      modalId: "import-forms-styling-modal",

      form_body_id: 0,
      showStyleDiv: true,
      hidePrevious: 'hide',
      formType: 'import_body_styling',
      isDefaultShow: false,
      defaultTheme: {},
    };
  },
  methods: {
    chooseExisting() {
      this.importFolder();
    },
    chooseDefault() {
      
      const header = this.defaultTheme.header_content;
      const theme_style = this.defaultTheme.body_style;
      const isDefaultTheme = true;
      this.importFolder(theme_style, header, isDefaultTheme);
    },
    createOwn() {
      this.form_body_id = this.formBodyId;
      this.active = 2;
    },
    saveBodystyle(bodystyle, headerContent) {
      this.importFolder(bodystyle, headerContent);
    },
    importFolder(style = [], headerContent = null, isDefaultTheme = false) {
      let url = `${actions.DOCUMENT_IMPORT_TO_MYLIBRARY}`;
      axiosPost(url, {
        bodyStyling: style,
        headerContent: headerContent,
        form_id: this.formId,
        is_default_theme: isDefaultTheme,
      }).then((response) => {
        this.$toastr.s(response.data.message);
        this.close_modal();
      }).catch(res => {});
    },
    getFormTheme() {
      this.preloader = true,
      axiosGet(actions.FORM_THEME_GET)
        .then((res) => {
          if (res.data.status == 'success' && res.data.result) {
              this.isDefaultShow = true;
              this.defaultTheme = res.data.result;
          }
          this.preloader = false;
        })
        .catch((error) => {
          
        });
    },
    previous() {
        this.active = 1;
    },
  },
  mounted() {
    this.getFormTheme();
  },
};
</script>
